<div class="atn-ds-accordion">
  <div
    class="atn-ds-accordion__header"
    (click)="toggle()"
  >
    <ng-content select="[header]"></ng-content>
  </div>
  <div
    class="atn-ds-accordion__content"
    [class.atn-ds-accordion__content-open]="isExpanded"
  >
    <ng-content select="[content]"></ng-content>
  </div>
</div>
